import { API, get, put, patch, remove, buildQueryParams } from "api";
import { OK } from "http-status-codes";

import { AnnotationAction, ApiAnnotationModel, ApiUpdateAnnotation } from "store/features/annotations/interfaces";
import { buildAnnotationsModel } from "./factories/annotations.factory";

export const getAnnotationsReq = async (
    headers: HeadersInit,
    matSpecId: number,
    adMaterialId: number,
    assetId?: number
) => {
    const queryParams = buildQueryParams({
        matspec: matSpecId,
        admaterial: assetId ? undefined : adMaterialId,
        asset: assetId,
        assetOnly: assetId ? !!assetId : undefined,
    });
    const { parsedBody } = await get<ApiAnnotationModel>(`${API.baseApiUrl}/annotations?${queryParams}`, { headers });

    if (parsedBody) {
        const { annotations, permissions } = parsedBody;

        return {
            permissions,
            annotations: buildAnnotationsModel(annotations, assetId ? "VISUAL" : "DEFAULT"),
        };
    }
};

export const submitAnnotationsReq = async (
    headers: HeadersInit,
    adMaterialId: number,
    action: AnnotationAction,
    annotations: ApiUpdateAnnotation[]
) => {
    const queryParams = buildQueryParams({
        admaterial: adMaterialId,
        action,
    });
    const { parsedBody: updatedAnnotationsModel } = await put<ApiAnnotationModel>(
        `${API.baseApiUrl}/annotations?${queryParams}`,
        { annotations },
        { headers }
    );

    if (updatedAnnotationsModel) {
        const { annotations, permissions } = updatedAnnotationsModel;
        return {
            annotations: buildAnnotationsModel(annotations, "DEFAULT"),
            permissions: permissions,
        };
    }
};

export const submitVisualAnnotationsReq = async (
    headers: HeadersInit,
    assetId: number,
    adMaterialId: number,
    action: AnnotationAction,
    annotations: ApiUpdateAnnotation[]
) => {
    const queryParams = buildQueryParams({
        admaterial: adMaterialId,
        asset: assetId,
        action,
    });
    const { parsedBody } = await put<ApiAnnotationModel>(
        `${API.baseApiUrl}/annotations?${queryParams}`,
        { annotations },
        { headers }
    );

    if (parsedBody) {
        const { annotations, permissions } = parsedBody;
        return {
            annotations: buildAnnotationsModel(annotations, "VISUAL"),
            permissions: permissions,
        };
    }
};

export const submitIsAnnotationReviewedReq = async (headers: HeadersInit, id: number, reviewed: boolean) => {
    await patch(`${API.baseApiUrl}/annotations/${id}?reviewed=${reviewed}`, undefined, { headers });

    return OK;
};

export const removeAnnotationReq = async (headers: HeadersInit, annotationId: number) => {
    await remove(`${API.baseApiUrl}/annotations/${annotationId}`, { headers });

    return OK;
};
